export default "__VITE_ASSET__9Fw8pfP$__"